import React, {useState} from "react";
import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import useInput from "../../hooks/useInput";
import usePostTarget from "../../hooks/usePostTarget";
import { Button } from "react-bulma-components";
import Collapsible from "react-collapsible";
import DepartmentSelector from "./Departments/DepartmentSelector";

function NewTarget({departments, loaded}) {
  let [weekly_target, amountInput] = useInput({
    type: "number",
    label: "Amount",
    currency: true
  });
  const [active_from, dateInput] = useInput({
    type: "date",
    label: "Active from"
  });
  let [active_to, activeToInput] = useInput({
    type: "date",
    label:
      "Active To (Leave blank if this is a new weekly target going forward)"
  });

  let [department, setDepartment] = useState("BLANK")

  active_to = active_to ? active_to : undefined;
  weekly_target = parseFloat(weekly_target);

  const onDepartmentChange = e => {
    setDepartment(departmentObjects[e.target.value]);
  }

  const [, postTarget] = usePostTarget({
    weekly_target,
    active_from,
    active_to,
    department
  });

  const handleSubmit = () => {
    postTarget();
  };

  const departmentObjects = loaded ? departments.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  return (
    <Box>
      <Collapsible
        className="title"
        triggerOpenedClassName="title"
        trigger="Add Target"
      >
        <Columns>
          {dateInput}
          {activeToInput}
          {amountInput}
          <Columns.Column>
            <DepartmentSelector
              blank={true}
              editable={true}
              name={"department"}
              options={departments}
              label={"Department"}
              onChange={onDepartmentChange}
              value={department}
            />
          </Columns.Column>
        </Columns>

        <Columns>
          <Columns.Column>
            <Button onClick={handleSubmit} fullwidth color={"success"}>
              Add
            </Button>
          </Columns.Column>
        </Columns>
      </Collapsible>
    </Box>
  );
}

export default NewTarget;
